<template>
  <v-text-field
    v-model="data_formatada"
    v-bind="$attrs"
    maxlength="10"
    :readonly="readonly"
    @input="onInput"
    @focus="onFocus"
  >
    <template v-slot:append-inner>
      <v-menu
        v-model="menu"
        transition="scale-transition"
        origin="center center"
        offset-y
        max-width="290px"
        min-width="290px"
        nudge-bottom="20px"
        :left="left"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ props }">
          <v-icon
            v-bind="props"
            v-show="!readonly"
            tabindex="-1"
            class="mr-2"
            @click="setYearPicker"
            >mdi-calendar</v-icon>
        </template>
        <v-date-picker
          v-model="date"
          ref="picker"
          location="pt-BR"
          :min="min"
          :max="max"
          @update:modelValue="onInputDatePicker"
        ></v-date-picker>
      </v-menu>
    </template>
  </v-text-field>
</template>

<script setup>

import { ref, watch } from 'vue';

// const data = defineModel();

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  min: {
    type: String,
    default: "1945"
  },
  max: {
    type: String,
    default: (new Date().getFullYear() + 1).toString()
  },
  birthday: {},
  left: {},
  validateFormat: {}
})

const emit = defineEmits(['update:modelValue'])


const data_formatada = ref("");
const date = ref(new Date());
const menu = ref(false);

function onInput(event) {
  let data = event.target.value;
  data = formataData(data);
  event.target.value = data.substring(0, 10);

  data_formatada.value = data;
  const dataUS = data.split('/').reverse().join('-') + ' 00:00';
  date.value = new Date(dataUS);
}

function formataData(data) {
  data = data.replace(/\D/g, ""); //Remove tudo o que não é dígito
  data = data.replace(/(\d{2})(\d)/, "$1/$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
  data = data.replace(/(\d{2})(\d)/, "$1/$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
  return data.substring(0, 10);
}

watch(data_formatada, (value) => {
  if (!!value && value.length == 10) {
    const dataUS = value.split('/').reverse().join('-');
    emit('update:modelValue', dataUS)
  }
})

watch(() => props.modelValue, (value) => {
    if (!value) {
      data_formatada.value = '';
      date.value = null;
      return;
    }
    const dataBR = value.split('-').reverse().join('/');
    const dataUS = value + ' 00:00';
    data_formatada.value = dataBR;
    date.value = new Date(dataUS);
  },{ immediate: true }
)

function onInputDatePicker(value) {
  const dataBR = value.toLocaleDateString('pt-BR', {timeZone: 'UTC'});
  data_formatada.value = dataBR;
  menu.value = false;
}

function onFocus(e) {
  e.target.selectionStart = 0;
  e.target.selectionEnd = e.target.value.length;
}

function setYearPicker() {
  // if (props.birthday) {
  //   setTimeout(() => {
  //     max.value = new Date().toISOString().sub(0, 10);
  //     $refs.picker.activePicker = 'YEAR';
  //   }, 0);
  // } else {
  //   max.value = null;
  // }
}

// function limpar() {
//   // data_formatada.value = '';
//   // date.value = '';
//   // emit('input', date.value);
// }

// function isValidDate(date) {
//   if (!props.validateFormat) {
//     return true;
//   }

//   if (!date) {
//     return true;
//   }

//   const message = "Data inválida. (DD/MM/AAAA)";

//   if (date.length < 10) {
//     return message;
//   }

//   let [ dia, mes, ano ] = date.split('/');

//   if (dia > 31 || mes > 12) {
//     return message;
//   }

//   let pattern = /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/;
//   return pattern.test(date) || message;
// }

</script>

<style scoped>

</style>
